import './WorkflowNavBar.scss';
import './NavBarShared.scss';

import React from 'react';
import PropTypes from 'prop-types';

import IdentityStore from 'stores/IdentityStore';
import connectStore from 'decorators/connectStore';

import AuthorAvatar from 'components/nav/authenticated/AuthorAvatar';
import NavLogo from 'components/nav/shared/NavLogo';

@connectStore(IdentityStore, 'identityState')
class WorkflowNavBarContainer extends React.Component {
  render() {
    return (
      <WorkflowNavBar {...this.props} />
    );
  }
}

class WorkflowNavBar extends React.Component {
  static propTypes = {
    centerNav: PropTypes.object,
    enableDesktopAvatar: PropTypes.bool,
    forceMobileWorkflow: PropTypes.bool,
    identityState: PropTypes.object.isRequired,
    leftNav: PropTypes.object,
    rightNav: PropTypes.object,
  };

  static defaultProps = {
    enableDesktopAvatar: true,
  };

  renderAvatar() {
    let avatar = null;
    const { currentIdentity } = this.props.identityState;

    if (currentIdentity && currentIdentity.claimedAuthorName) {
      avatar = (
        <div className="avatar-container hidden-xs">
          <div className="aa-avatar-nav">
            <AuthorAvatar
              authorName={currentIdentity.claimedAuthorName}
              amazonAuthorId={currentIdentity.amazonAuthorId}
            />
          </div>
        </div>
      );
    }

    return avatar;
  }

  renderLogo() {
    return (
      <div>
        <div className="pull-left">
          <div className="hidden-xs">
            <NavLogo />
          </div>
        </div>
        <div className="visible-xs-block">
          <NavLogo />
        </div>
      </div>
    );
  }

  render() {
    let navClassName = 'aa-workflow-navbar navbar navbar-inverse navbar-fixed-top';
    if (this.props.forceMobileWorkflow) {
      navClassName += ' aa-workflow-navbar-mobile';
    }
    return (
      <nav className={navClassName}>
        <div className="nav-container container-fluid">
          <div className="pull-left">
            {this.props.leftNav}
          </div>

          {this.props.centerNav || this.renderLogo()}

          <div className="pull-right">
            {this.props.rightNav}
            {!this.props.forceMobileWorkflow
              && this.props.enableDesktopAvatar && this.renderAvatar()}
          </div>
        </div>
      </nav>
    );
  }
}

export default WorkflowNavBarContainer;
